import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { SecurityDepositSettingValidation } from 'uplisting-frontend/validations';

export default class SecurityDepositSettingRepositoryService extends BaseRepositoryService<
  ModelRegistry['security-deposit-setting']
> {
  recordName = 'security-deposit-setting';
  implementMethods = ['findAll', 'unloadAll', 'peekAll', 'buildChangeset'];

  validation = SecurityDepositSettingValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/security-deposit-setting': SecurityDepositSettingRepositoryService;
  }
}
